import {useTranslation} from "@Translation/hooks/useTranslation";
import roundToTwoDecimals from "@Number/roundToTwoDecimals";
import VehicleAddonType from "@CheckOrder/types/VehicleAddon.type";
import {
    displayMotorcycleVehicleLength
} from "@CheckOrder/features/addons/features/jadrolinija/constants/vehicleLengths";
import checkPassengerGroupType
    from "@CheckOrder/features/addons/features/jadrolinija/functions/checkPassengerGroupType";
import usePurchasedRoute from "@CheckOrder/hooks/usePurchasedRoute";

export default function useCreateSelectedVehicleDescription(vehicle: VehicleAddonType) {
    const {
        additional_height: {
            title: additionalHeightLabel,
        },
        additional_length: {
            title: additionalLengthLabel,
        },
        length: {
            title: lengthLabel,
        },
    } = useTranslation("check_order.addons.JADL.vehicle")

    const {
        passengerGroups,
        returnPassengerGroups,
    } = usePurchasedRoute()

    const passengerGroupName = {...passengerGroups, ...returnPassengerGroups}?.[vehicle.singlePassengerGroupId]?.name

    const prepareSizeInfo = (size: number) => (
        `${roundToTwoDecimals(size / 100)}m`
    )

    const {isCar, isMotorcycle} = checkPassengerGroupType()

    const lengthInfo = () => {
        if (isCar(vehicle)) {
            return `${additionalLengthLabel}: ${prepareSizeInfo(vehicle.additionalLength)}`
        }

        if (isMotorcycle(vehicle)) {
            return vehicle.additionalLength > displayMotorcycleVehicleLength ? `${lengthLabel}: > ${prepareSizeInfo(displayMotorcycleVehicleLength)}` : `${lengthLabel}: < ${prepareSizeInfo(displayMotorcycleVehicleLength)}`
        }

        return ""
    }

    const heightInfo = () => {
        if (isCar(vehicle)) {
            return `${additionalHeightLabel}: ${prepareSizeInfo(vehicle.additionalHeight)}`
        }

        return ""
    }
    const getVehicleInfo = () => {
        if (isCar(vehicle)) {
            return `${vehicle.brand} ${vehicle.model}, ${vehicle?.registrationNumber ?? ""}`
        }

        if (isMotorcycle(vehicle)) {
            return `${passengerGroupName}, ${vehicle.registrationNumber}`
        }

        return `${passengerGroupName}`
    }

    const removeNonexistingInfo = (infos: string[]) => (
        infos.filter((info) => (info))
    )

    const vehicleInfo = getVehicleInfo()
    const sizeInfo = removeNonexistingInfo([lengthInfo(), heightInfo()]).join(", ")

    return removeNonexistingInfo([vehicleInfo, sizeInfo])
}